import { ThreeEvent, useFrame } from '@react-three/fiber'
import { UnitDisplayPropertiesFn } from 'features/siteMapViz'
import { SiteViewRaycastConfig, useSiteViewContext } from 'features/siteView'
import { isNil } from 'lodash'
import { TilesetMapFeatureDispatch } from 'pages/siteView/siteMap/tilesetMap/features/TilesetMapFeatureDispatch'
import { useTilesetMapFeatureHelpers } from 'pages/siteView/siteMap/tilesetMap/features/useTilesetMapFeatureHelpers'
import React from 'react'
import { Vector3 } from 'three'

const zero = new Vector3(0, 0, 0)

interface TilesetMapRaycastIndicatorProps {
  config: SiteViewRaycastConfig
  getUnitDisplayProperties: UnitDisplayPropertiesFn
  getUnitDisplayName: (unitID: string) => string | undefined
}

export const TilesetMapRaycastIndicator: React.FC<
  TilesetMapRaycastIndicatorProps
> = (props) => {
  const { setSiteViewRaycastConfig } = useSiteViewContext()
  const { convertPositionToCartographic } = useTilesetMapFeatureHelpers()

  useFrame((state) => {
    state.raycaster.setFromCamera(state.pointer, state.camera)

    const pos =
      state.raycaster
        .intersectObjects(state.scene.children, true)
        ?.find((hit) => hit.object.name !== props.config.primitive.id)?.point ??
      zero

    setSiteViewRaycastConfig({
      ...props.config,
      primitive: {
        ...props.config.primitive,
        coordinate: convertPositionToCartographic(pos)!,
      },
    })
  })

  return (
    <group
      onClick={(e: ThreeEvent<MouseEvent>) => {
        // TODO: don't fire callback when map has been dragged
        if (props.config.clickCallback) {
          props.config.clickCallback(e, props.config.primitive.coordinate)
        }
      }}>
      <TilesetMapFeatureDispatch
        feature={props.config.primitive}
        featureDisplayName={
          isNil(props.config.primitive.unit_id)
            ? undefined
            : props.getUnitDisplayName(props.config.primitive.unit_id)
        }
        key='raycast'
        visible={true}
        getUnitDisplayProperties={props.getUnitDisplayProperties}
        getExtraLabelDisplay={() => null}
      />
    </group>
  )
}
